import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus } from "../../actions"
import Modal from "react-responsive-modal"
import * as Yup from "yup"
import moment from "moment"

class OfficeModal extends Component {
	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		const { open, data } = this.props
		let int
		if (data.lot_id) {
			int = _.find(this.props.payload.exec.lots, { id: data.lot_id })
		} else {
			int = _.find(this.props.payload.public.floorplans, { id: data.floorplan })
		}
		let interest
		if (data.lot_id && int) {
			interest = int.address
		} else if (data.floorplan && int) {
			interest = int.name
		}
		let type
		if(data.lot_id) type = "Lot"
		else if (data.floorplan) type = "Floorplan"
		else type = "General"
		return (
			<div>
				<Modal classNames={{ modal: "modalForm" }} open={open} onClose={this.props.onClose} center>
					<div className="modal">
						<ul className="modalForm__list">
							<li className="form__listItem">
								<label htmlFor="floorplan">Type</label>
								{type}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Interest</label>
								{interest}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">First Name</label>
								{data.first_name}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Last Name</label>
								{data.last_name}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Email</label>
								{data.email}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Zip</label>
								{data.zip}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Phone</label>
								{data.phone}
							</li>
							{data?.street ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">Street</label>
									{data.street}
								</li>
							) : null}
							{data?.city ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">City</label>
									{data.city}
								</li>
							) : null}
							{data?.state ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">State</label>
									{data.state}
								</li>
							) : null}
							{data?.zip ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">Zip</label>
									{data.zip}
								</li>
							) : null}
							{data?.timeframe ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">Timeframe</label>
									{data.timeframe}
								</li>
							) : null}
							{data?.price_range ? (
								<li className="form__listItem">
									<label htmlFor="floorplan">Price Range</label>
									{data.price_range}
								</li>
							) : null}
							<li className="form__listItem">
								<label htmlFor="floorplan">Message</label>
								{data.message}
							</li>
							<li className="form__listItem">
								<label htmlFor="floorplan">Date</label>
								{moment.unix(data.addedDate).format("MM/DD/YY LT")}
							</li>
						</ul>
					</div>
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(OfficeModal)
